import React, { Component } from "react";
import { observer, inject } from "mobx-react";

import styled from "styled-components";
import { Popover } from "@material-ui/core";
import { IValuesStore } from "@src/Stores/Values/types";

const STFrame = styled.iframe`
  border: none;
  width: 100%;
  margin-bottom: -5px;
  height: 300px;
`;

export interface IProps {
  isOpened: boolean;
  onClose: () => void;
  anchorEl: HTMLElement;
  values?: IValuesStore;
}

@inject("values")
@observer
export default class ComponentAppFrame extends Component<IProps> {
  render() {
    return (
      <Popover
        id="render-props-popover"
        open={this.props.isOpened}
        anchorEl={this.props.anchorEl}
        onClose={this.props.onClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <STFrame
          src={`${window.location.origin}/apps?applicationToSkip=${this.props.values.applicationId}&clientWidth=${window.innerWidth}`}
        />
      </Popover>
    );
  }
}
